import {Component, View, ViewEncapsulation} from 'angular2/core';
import {ROUTER_DIRECTIVES} from 'angular2/router';

let template = require('./sidebar.html');

@Component({
  selector: 'afeb-sidebar',
})
@View({
  template: template,
  directives: [ROUTER_DIRECTIVES]
})
export class Sidebar {

}



/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./src/layout/sidebar/sidebar.ts
 **/